import { message, Trigger } from "@ss/mtd-react";
import download from "downloadjs";
import { findDOMNode } from "react-dom";
import qs from "qs";
import { currentInitConfig } from "@/utils/init";
import randomString from "randomstring";

const contentTypeMap = {
    zip: "application/zip",
    png: "image/png",
    svg: "image/svg+xml",
    font: "application/zip",
    project: "application/zip"
};
/**
 * fetch 请求
 * @param obj 传入对象
 * @param return &12&12
 */
export function encodeSearchParams(obj) {
    const params = [];

    Object.keys(obj).forEach(key => {
        let value = obj[key];
        // undefined置空
        if (typeof value === "undefined") {
            value = "";
        }
        // 编码
        params.push([key, encodeURIComponent(value)].join("="));
    });

    return params.join("&");
}

/**
 * 出去没有意义的参数
 * @param url 请求的url
 * @param param 请求的参数
 */
export function handleFilterData(data) {
    let obj = {};
    for (let key in data) {
        if (data[key] != undefined) {
            obj[key] = data[key];
        }
    }
    return obj;
}

export async function ajax(url, param, method) {
    param = handleFilterData(param);
    let _options = {
        credentials: "same-origin"
    };
    _options.method = method;
    if (!_options.headers) {
        _options.headers = {
            Accept: "application/json",
            "Content-Type": "application/json"
        };
    } else {
        !_options.headers["Accept"] &&
            (_options.headers["Accept"] = "application/json");
        !_options.headers["Content-Type"] &&
            (_options.headers["Content-Type"] = "application/json");
    }
    if (param) {
        if (method == "GET") {
            if (Object.keys(param).length != 0) {
                url = `${url}?${encodeSearchParams(param)}`;
            }
        } else if (method == "POSTFILE") {
            // 强制delete默认header, 浏览器会自动为header添加content-type: multipart/formdata, --bodury---
            _options.headers = {};
            const formData = new FormData();
            Object.keys(param).forEach(key => {
                const isArray =
                    Object.prototype.toString.call(param[key]) ===
                    "[object Array]";
                if (isArray) {
                    // formdata数组特殊处理
                    for (let i = 0; i < param[key].length; i++) {
                        formData.append(key + "[]", param[key][i]);
                    }
                } else {
                    formData.append(key, param[key]);
                }
            });
            _options.body = formData;
            _options.method = "post";
        } else if (method == "POSTFILEWITHENCODE") {
            _options.headers = {};
            const formData = new FormData();
            Object.keys(param).forEach(key => {
                const isArray =
                    Object.prototype.toString.call(param[key]) ===
                    "[object Array]";
                if (isArray) {
                    // formdata数组特殊处理
                    for (let i = 0; i < param[key].length; i++) {
                        const encodeFileName = encodeURIComponent(
                            param[key][i].name
                        );
                        formData.append(
                            key + "[]",
                            param[key][i],
                            encodeFileName
                        );
                    }
                } else {
                    const encodeFileName = encodeURIComponent(param[key].name);
                    formData.append(key, param[key], encodeFileName);
                }
            });
            _options.body = formData;
            _options.method = "post";
        } else {
            try {
                _options.body = JSON.stringify(param);
            } catch (e) {
                console.log("上传参数出错:", e);
            }
        }
    }
    !_options["credentials"] && (_options["credentials"] = "same-origin");
    const newUrl = url.replace("/assets-internal/", "/assets-internal/v2/");
    return fetch(newUrl, _options)
        .then(res => res.json())
        .then(
            function(res) {
                if (res.code == 401 || res.status === 401) {
                    if (res?.redirectUrl) {
                        window.location.href = res.redirectUrl;
                    } else {
                        message.info({
                            message:
                                "There was a minor issue, we are currently refreshing for you"
                        });
                        return login();
                    }
                } else {
                    if (res.code == 200) {
                        return res.data;
                    } else if (res.code == 150) {
                        message.error({
                            message: res.message
                        });
                        return null;
                    }
                    return Promise.reject(
                        res.message || "please try again later"
                    );
                }
            },
            function(e) {
                return Promise.reject(e.message || "network anomaly");
            }
        )
        .catch(error => {
            message.error({
                message: error
            });
            throw error;
        });
}

/**
 * 得到当前月份区间
 */
export function getRangeMonth() {
    let dateNow = new Date();
    let year = dateNow.getFullYear();
    let month = dateNow.getMonth() + 1;
    let newDate = new Date(year, month, 0);
    let days = newDate.getDate();
    return [`${year}-${month}-01`, `${year}-${month}-${days}`];
}

/**
 * 金额格式化
 * eg
 * 1234.00 => 1,234.00
 */
export function numberFormat(v) {
    if (!v) {
        return 0.0;
    }
    v =
        v == Math.floor(v)
            ? v + ".00"
            : v * 10 == Math.floor(v * 10)
            ? v + "0"
            : v;
    v = String(v);
    let ps = v.split("."),
        whole = ps[0],
        sub = ps[1] ? ps[1] : "",
        r = /(\d+)(\d{3})/;

    while (r.test(whole)) {
        whole = whole.replace(r, "$1" + "," + "$2");
    }

    v = whole + "." + sub;

    if (v.charAt(0) == "-") {
        return "-" + v.substr(1);
    }
    return v;
}

/**
 * 下载图片
 */
export function downloadImg(url) {
    if (XMLHttpRequest) {
        let x = new XMLHttpRequest();
        x.open("GET", url.replace("http://", "//"), true);
        x.responseType = "blob";
        x.onload = function(res) {
            download(
                res.target.response,
                url.slice(url.lastIndexOf("/") + 1) || "simpleImg"
            );
        };
        x.send();
    }
}
// 前端下载资源
export function handleDownloadResource(url) {
    url = url.replace("https://", "//");
    let xhr = new XMLHttpRequest();
    xhr.open("get", url, true);
    xhr.responseType = "blob";
    xhr.onerror = function(err) {
        message.error({
            message: "Download failed"
        });
    };
    xhr.onload = function(res) {
        download(res.target.response, url.slice(url.lastIndexOf("/") + 1));
    };
    xhr.send();
}

export const handleDownloadResourceWithName = url => {
    const downloadTypes = Object.values(contentTypeMap);
    url = url
        .replace("https://", "//")
        .replace("/assets-internal/", "/assets-internal/v2/");
    let xhr = new XMLHttpRequest();
    xhr.open("get", url, true);
    xhr.responseType = "blob";
    xhr.onerror = function(err) {
        message.error({
            message: "Download failed"
        });
    };
    xhr.onload = function(res) {
        const contentType = res.target.getResponseHeader("Content-Type");
        if (
            res.target.status === 200 &&
            downloadTypes.some(type => contentType.includes(type))
        ) {
            const contentDisposition = res.target.getResponseHeader(
                "Content-Disposition"
            );
            let filename = "downloaded_file";
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(
                    /filename\*\s*=\s*UTF-8''([^;]+)/
                );
                if (filenameMatch && filenameMatch[1]) {
                    filename = decodeURIComponent(
                        filenameMatch[1].replace(/['"]/g, "")
                    );
                }
            }
            download(res.target.response, filename);
        } else {
            if (contentType && contentType.includes("application/json")) {
                // 使用 FileReader 读取 blob 内容
                const reader = new FileReader();
                reader.onload = function(event) {
                    try {
                        const json = JSON.parse(event.target.result);
                        message.error({
                            message: json.message || "Download failed"
                        });
                    } catch (e) {
                        message.error({
                            message: "Download failed"
                        });
                    }
                };
                reader.onerror = function() {
                    message.error({
                        message: "Download failed"
                    });
                };

                try {
                    reader.readAsText(res.target.response);
                } catch (e) {
                    message.error({
                        message: "Download failed"
                    });
                }
            } else {
                message.error({
                    message: "Download failed"
                });
            }
        }
    };
    xhr.send();
};

/**
 * 获取指定的 url 参数
 * @param str
 * @param paramName
 */
export function getUrlParameter(str, paramName) {
    if (!str) {
        return null;
    }
    let queryString = str;
    if (queryString.length > 1 && queryString[0] === "?") {
        queryString = queryString.slice(1);
    }
    const params = queryString.split("&");
    for (let i = 0; i < params.length; i += 1) {
        const val = params[i].split("=");
        if (val[0] === paramName) {
            return val[1];
        }
    }
    return null;
}

/**
 * 判断当前页面是否在iframe中
 * to do
 */
export function isInIframe() {
    const inFrame = window.self !== window.top;
    return inFrame;
}

export function isArrayNotEmpty(maybeArray) {
    const isArray =
        Object.prototype.toString.call(maybeArray) === "[object Array]";
    return isArray && maybeArray.length >= 1;
}

export function ApiError({ message, errorCode, ...data }) {
    this.name = "ApiError";
    this.message = message;
    this.errorCode = errorCode;
    this.data = data;
    this.stack = new Error().stack;
}
ApiError.prototype = Object.create(Error.prototype);
ApiError.prototype.constructor = ApiError;

export function ApiStatusError() {
    ApiError.apply(this, arguments);
}
ApiStatusError.prototype = Object.create(ApiError.prototype);
ApiStatusError.prototype.constructor = ApiStatusError;

export async function regularApi(url, params) {
    console.log(url, params);
    let res = await fetch(url, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest" // FIXME: 使登录失效时不往 SSO 跳转，临时方案
        },
        body: JSON.stringify(params),
        credentials: "same-origin"
    });
    res = await res.json();
    if (res.status == 1) {
        return res.data;
    } else if (res.status == 401) {
        // throw new ApiStatusError({ errorCode: 401 }); // 兼容新版SSO登陆失效时候返回的
        return login();
    } else {
        throw new ApiStatusError(res.data);
    }
}

export const cookie = {
    /**
     * 获取cookie的值
     *
     * @method get
     * @param a {String} cookie中得key
     * @param b [placeholder]
     * @return {String}
     */
    get: function(a, b) {
        b = document["cookie"].match(
            "(?:;|^)\\s*" + a + "\\s*=\\s*([^;]+)\\s*(?:;|$)"
        );
        return b && b[1];
    },
    /**
     * 设置cookie的值
     *
     * @method set
     * @param a {String} key
     * @param b {String|Number} value
     * @param c {number} expiration time(s)
     */
    set: function(a, b, c) {
        document["cookie"] =
            a +
            "=" +
            b +
            (c
                ? "; expires=" +
                  new Date(new Date().getTime() + c * 1000).toGMTString()
                : "") +
            "; path=/";
    },
    /**
     * 删除cookie的值
     *
     * @method set
     * @param a {String} key
     */
    remove: function(a) {
        document["cookie"] = a + "=" + "; expires=" + new Date().toGMTString();
    }
};
let refreshing = false;

export function autoRelogin(maxTimes = 3) {
    if (refreshing) return true;
    let loginInvalidTimes = cookie.get("login_invalid_times") || 0;
    if (loginInvalidTimes < maxTimes) {
        cookie.set(
            "login_invalid_times",
            ++loginInvalidTimes,
            new Date().setHours(26, 0, 0, 0)
        );
        window.location.reload();
        return true;
    } else {
        return false;
    }
}

/**
 * 根据配置生成水印url
 * 直接调用时要求传入backgroundColor
 * @param {*} config
 */
export function getWatermarkUrl(config) {
    // TO REMOVE
    if (config.hasOwnProperty("non_blind")) {
        console.warn("non_blind属性即将弃用，请更换为type属性");
    }

    const { url, urlPrefix, backgroundColor, non_blind, type } = config;
    let bgColor = backgroundColor;
    let imgUrl;
    if (!!url) {
        imgUrl = url;
    } else {
        // 如果是十六进制传入，作转换
        if (/^#[0-9a-fA-F]+$/.test(bgColor)) {
            const backgroundColorLength = bgColor.length;
            const result = [];
            if (backgroundColorLength === 4) {
                for (let i = 1; i < backgroundColorLength; i++) {
                    const char = bgColor.charAt(i);
                    result.push(parseInt(`${char}${char}`, 16));
                }
            } else if (backgroundColorLength == 7) {
                for (let i = 1; i < backgroundColorLength; i += 2) {
                    const chars = bgColor.substring(i, i + 2);
                    result.push(parseInt(chars, 16));
                }
            }
            bgColor =
                result.length > 0
                    ? `rgb(${result[0]},${result[1]},${result[2]})`
                    : "";
        }

        const result = /^rgba?\((\d+), ?(\d+), ?(\d+)(, ?(\d+))?\)$/.exec(
            bgColor
        );
        if (result) {
            const [c, r, g, b, t, a] = result;

            const prefix = urlPrefix ? urlPrefix : "/api-wm";
            if (type === "non-blind" || non_blind) {
                // TODO 后端暂时全部给默认配置，之后会支持配置
                imgUrl = `${prefix}/image/visible`;
            } else if (type === "mixed") {
                const hexBgColor = [r, g, b]
                    .map(c => Number(c).toString(16))
                    .join("");
                imgUrl = `${prefix}/image/mix?bgColor=${hexBgColor}`;
            } else if (a !== "0") {
                // 如果是暗水印且非全透明的
                imgUrl = `${prefix}/image?r=${r}&g=${g}&b=${b}`;
            }
        }
    }
    return imgUrl;
}

export function setWatermark(instance, config = { type: "blind" }) {
    const node = findDOMNode(instance);
    if (node) {
        const { backgroundColor } = config;
        let bgColor;
        if (!!backgroundColor) {
            bgColor = backgroundColor;
        } else {
            bgColor = window
                .getComputedStyle(node)
                .getPropertyValue("background-color");
        }
        const imgUrl = getWatermarkUrl({ ...config, backgroundColor: bgColor });
        !!imgUrl && (node.style.backgroundImage = `url(${imgUrl})`);
    }
}

/**
 * 修饰器，为组件添加水印方法
 * @param auto 是否自动在组件上加水印
 * @param config 自动加水印时可传入自定义配置
 *  {
 *    refNames: [], // 自动加水印的组件实例ref名列表，如果不传或者传入的是空数组，则默认在组件上增加
 *
 *    // 如果传入字符串则每个实例都以相同的颜色添加水印背景色，否则按数组一一对应
 *    // 传入数组时可以跳过某个实例不传，则默认从该实例上获取水印背景色
 *    backgroundColor: '' || [],
 * }
 * @returns {Function}
 */
export function withWatermark(auto, config = {}) {
    return function(target) {
        if (auto) {
            const method = "componentDidMount";
            const originMethod = target.prototype[method];
            target.prototype[method] = function() {
                const { backgroundColor, type, refNames, ...conf } = config;
                if (refNames && refNames.length > 0) {
                    for (let i = 0, length = refNames.length; i < length; i++) {
                        const name = refNames[i];
                        // 渲染实例可能挂在this.refs也可能直接挂在this上
                        const ins = this.refs[name] || this[name];
                        const insBackgroundColor =
                            backgroundColor instanceof Array
                                ? backgroundColor[i]
                                : backgroundColor;
                        const insType = type instanceof Array ? type[i] : type;
                        if (!ins) {
                            console.warn(
                                `this.refs.${name}`,
                                " 初始加载时不存在"
                            );
                            continue;
                        }
                        setWatermark(ins, {
                            ...conf,
                            backgroundColor: insBackgroundColor,
                            type: insType
                        });
                    }
                } else {
                    setWatermark(this, config);
                }

                const inheritedMethod = Object.getPrototypeOf(target.prototype)[
                    method
                ];
                if (typeof inheritedMethod === "function") {
                    inheritedMethod.apply(this, arguments);
                }
                if (typeof originMethod === "function") {
                    return originMethod.apply(this, arguments);
                }
            };
        }
        Object.assign(target.prototype, { setWatermark });
    };
}

export const Ajax = {
    get: async (url, param = {}) => ajax(url, param, "GET"),
    post: async (url, param = {}) => ajax(url, param, "POST"),
    put: async (url, param = {}) => ajax(url, param, "PUT"),
    postFile: async (url, param = {}) => ajax(url, param, "POSTFILE"),
    postFileWithEncode: async (url, param = {}) =>
        ajax(url, param, "POSTFILEWITHENCODE")
};

export async function fetchData(urlInfo, params) {
    return await Ajax[urlInfo.method](urlInfo.url, params);
}

const DEPLOY_ENV = process.env.REACT_APP_DEPLOY_ENV;
export const isOnline = DEPLOY_ENV === "production" || DEPLOY_ENV === "staging";
export const getAILink = value =>
    isOnline
        ? `https://huamei.sankuai.com/#/create/MJ?modal=Midjourney&value=${value}`
        : `https://aic.vision.test.sankuai.com/#/create?modal=Midjourney&value=${value}`;
export const getIconfontOrignLink = resource =>
    isOnline
        ? `https://iconfont.sankuai.com/${resource}`
        : `https://iconfont.waimai.test.sankuai.com/${resource}`;

/**
 * 接口401 获取sso登录地址
 */
const getSSOLoginUrl = () => {
    // 登录域名
    const loginOrigin = `https://ssosv.${
        DEPLOY_ENV === "production" || DEPLOY_ENV === "staging"
            ? ""
            : "it.test."
    }sankuai.com/sson/login`;
    // clientId
    const clientId =
        DEPLOY_ENV === "production" || DEPLOY_ENV === "staging"
            ? "173b11e09f"
            : "48515cee11";
    const { origin, href } = window.location;
    const currentPath = href.replace(new RegExp(`^${origin}`), "");
    return `${loginOrigin}?client_id=${clientId}&redirect_uri=${encodeURIComponent(
        `${origin}/mtd-api/assets-internal/nsso/callback?original-url=${encodeURIComponent(
            currentPath
        )}`
    )}`;
};

export const login = () => {
    const url = getSSOLoginUrl();
    window.location.href = url;
};
export const logout = () => {
    const url = getSSOLogoutUrl();
    window.location.href = url;
};

/**
 * 主动登出path
 */
export const getSSOLogoutUrl = () => {
    const logoutOrigin = `https://ssosv.${
        DEPLOY_ENV === "production" || DEPLOY_ENV === "staging"
            ? ""
            : "it.test."
    }sankuai.com/sson/logout`;
    // clientId
    const clientId =
        DEPLOY_ENV === "production" || DEPLOY_ENV === "staging"
            ? "173b11e09f"
            : "48515cee11";
    const { origin, href } = window.location;
    const currentPath = href.replace(new RegExp(`^${origin}`), "");
    return `${logoutOrigin}?client_id=${clientId}&redirect_uri=${encodeURIComponent(
        `${origin}/mtd-api/assets-internal/nsso/callback?original-url=${encodeURIComponent(
            currentPath
        )}`
    )}`;
};

// export default {
//   downloadImg,
//   numberFormat,
//   getRangeMonth,
//   encodeSearchParams,
//   isArrayNotEmpty,
//   Ajax,
//   withWatermark,
//   ApiError,
//   ApiStatusError,
//   regularApi
// }

export const isBudgetV2 = () => {
    const search = window.location.search;
    if (!search) {
        return false;
    }
    const searchParams = new URLSearchParams(search);
    return searchParams.get("budgetv2") === "true";
};

let fakeElem;
export const copy = content => {
    if (!fakeElem) {
        fakeElem = document.createElement("textarea");
        fakeElem.style.cssText =
            "border: 0;padding: 0;margin: 0; position: absolute; left: -9999px;";
    }

    fakeElem.setAttribute("readonly", "");
    fakeElem.value = content;

    document.body.appendChild(fakeElem);

    fakeElem.select();
    document.execCommand("copy");
};

// 实时打标
export async function generateTagsOnline(picUrl) {
    if (!picUrl) {
        return [];
    }
    const { host, task, version } = currentInitConfig().tagHost;
    const params = {
        url: picUrl,
        task,
        version
    };
    const query = qs.stringify(params);
    try {
        const res = await fetch(`${host}?${query}`);
        const data = await res.json();
        const { cls, code, message } = data;
        // 0代表成功，非0代表失败 https://km.sankuai.com/collabpage/1629143247
        if (code === 0) {
            const tag = [];
            cls.map(obj => {
                for (const tagName in obj) {
                    tag.push(tagName);
                }
            });
            return tag;
        } else {
            message.error({
                message: "Online marking failed!" + message
            });
            return [];
        }
    } catch (e) {
        message.error({
            message: e
        });
        return [];
    }
}
export function generateId() {
    const now = new Date();
    const year = now.getFullYear();
    let month = now.getMonth() + 1;
    let day = now.getDate();
    let hour = now.getHours();
    let minutes = now.getMinutes();
    let seconds = now.getSeconds();
    if (String(month).length < 2) {
        month = "0" + month;
    }
    if (String(day).length < 2) {
        day = "0" + day;
    }
    if (String(hour).length < 2) {
        hour = "0" + hour;
    }
    if (String(minutes).length < 2) {
        minutes = "0" + minutes;
    }
    if (String(seconds).length < 2) {
        seconds = "0" + seconds;
    }
    const yyyyMMddHHmmss = `${year}${month}${day}${hour}${minutes}${seconds}`;
    const prefix = randomString.generate({
        length: 3,
        readable: true,
        charset: "alphabetic"
    });
    return `${prefix}_${yyyyMMddHHmmss}`;
}

export const getSearchPicBtnVisible = previewImgUrl => {
    let isMTImage = false;
    // s3图片处理
    if (/s3plus/.test(previewImgUrl)) {
        isMTImage = true;
    }
    // venus图片处理
    const VenusPicSymbol = [
        "p0.inf.test.sankuai.com",
        "p0.meituan.net",
        "p1.meituan.net",
        "img.meituan.net"
    ];
    for (const item of VenusPicSymbol) {
        if (previewImgUrl?.includes(item)) {
            isMTImage = true;
        }
    }
    return isMTImage;
};
